import { Flex, Stack, useColorModeValue } from "@chakra-ui/react";
import { useEffect } from "react";
import { Children, cloneElement, useState } from "react";
import useSmallScreen from "../../components/useSmallScreen";

function GroupMobileBottomNavigation({ current = 0, children }) {
  const [smallScreen] = useSmallScreen();
  const [clickState, setClickState] = useState(current);
  const containerColor = useColorModeValue("#fff", "#020B19");

  const first = Children.toArray(children)[0];
  const second = Children.toArray(children)[1];
  const third = Children.toArray(children)[2];

  useEffect(() => {
    setClickState(current);
  }, [current]);

  const mobileStyle = {
    maxH: "80vh",
    overflowY: "scroll",
  };
  return (
    <>
      <Flex {...(smallScreen ? mobileStyle : {})}>
        {!smallScreen ? (
          <Stack
            direction={["column", "row"]}
            alignItems="flex-start"
            bg={containerColor}
            p="10px"
            w="100%"
            borderRadius={"15px"}
          >
            {cloneElement(first)}

            {cloneElement(second)}
            {cloneElement(third)}
          </Stack>
        ) : clickState === 0 ? (
          <Stack
            direction={["column", "row"]}
            alignItems="flex-start"
            bg={containerColor}
            p="10px"
            w="100%"
            borderRadius={"15px"}
          >
            {cloneElement(first)}
          </Stack>
        ) : clickState === 1 ? (
          cloneElement(second)
        ) : clickState === 2 ? (
          cloneElement(third)
        ) : (
          <Stack
            direction={["column", "row"]}
            alignItems="flex-start"
            bg={containerColor}
            p="10px"
            borderRadius={"15px"}
          >
            {cloneElement(first)}
            {cloneElement(second)}
            {cloneElement(third)}
          </Stack>
        )}
      </Flex>
    </>
  );
}

export default GroupMobileBottomNavigation;
